<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M20 17.28V6.72c.6-.35 1-.98 1-1.72a2 2 0 0 0-2-2 2 2 0 0 0-2 2c0 .74.4 1.38 1 1.72V11h-5V6.72c.6-.35 1-.98 1-1.72a2 2 0 0 0-2-2 2 2 0 0 0-2 2c0 .74.4 1.38 1 1.72V11H6a2 2 0 0 0-2 2v4.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-.74-.4-1.38-1-1.72V13h5v4.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-.74-.4-1.38-1-1.72V13h5v4.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-.74-.4-1.38-1-1.72Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
